<template>
  <div>
    <div class="conditions-box">
      <diV class="conditions-box-shadow">
      </diV>
      <div class="conditions-box-content container">
        <div class="row condition-box-header">
          <div class="col-md-12">
            <i class="fas fa-search mr-2"></i><b>条件を変更する</b>
          </div>
          <div class="col-md-12">
            <hr class="condition-box-hr">
          </div>
        </div>
        <div class="col-md-12">
          <search-form
            label="所在地"
            :items="placeItems"
            @delete-item="deletePlaceItem"
            @click-plus="openPlaceModal"
          ></search-form>
          <select-place-modal
            ref="selectPlaceModal"
            :isActive="activePlaceModal"
            :places="places"
            :initPlace="this.conditions.cities.map(x => {return {id: x.id, label: x.prefecture_name + '/' + x.name}})"
            @close="closePlaceModal"
            @add-place="addPlace"
          />
          <search-form
            label="施設"
            :items="facilityTypeItems"
            @delete-item="deleteFacilityItem"
            @click-plus="openFacilityTypeModal"
          ></search-form>
          <select-item-modal
            ref="selectFacilityTypeModal"
            item-name="施設"
            :initItems="this.conditions.facility_types.map(x => {return {id: x.id, label: x.name}})"
            :isActive="activeFacilityTypeModal"
            :items="facilityTypes"
            @close="closeFacilityTypeModal"
            @add-item="addFacilityType"
          />
          <search-form
            label="競技"
            :items="sportsTypeItems"
            @delete-item="deleteSportsTypeItem"
            @click-plus="openSportsTypeModal"
          ></search-form>
          <select-item-modal
            ref="selectSportsTypeModal"
            item-name="競技"
            :initItems="this.conditions.sports_types.map(x => {return {id: x.id, label: x.name}})"
            :isActive="activeSportsTypeModal"
            :items="sportsTypes"
            @close="closeSportsTypeModal"
            @add-item="addSportsType"
          />
          <search-form
            label="料金"
            :items="priceItems"
            @delete-item="deletePriceItem"
            @click-plus="openPriceModal"
          ></search-form>
          <select-price-modal
            ref="selectPriceModal"
            :isActive="activePriceModal"
            :prices="prices"
            :initPrice="this.conditions.price_ranges.map(x => {return {id: x.id, label: x.price_use_unit_name + '/' + x.name}})"
            @close="closePriceModal"
            @add-price="addPrice"
          />
          <search-form
            label="タグ"
            :items="tagItems"
            @delete-item="deleteTagItem"
            @click-plus="openTagModal"
          ></search-form>
          <select-item-modal
            ref="selectTagModal"
            item-name="タグ"
            :isActive="activeTagModal"
            :items="tags"
            :initItems="this.conditions.tags.map(x => {return {id: x.id, label: x.name}})"
            @close="closeTagModal"
            @add-item="addTag"
          />
          <search-form
            :label="isNoSearchAvailability ? '期間' : '空き有り'"
            :items="availabilityItems"
            @delete-item="deleteAvailabilityItem"
            @click-plus="isLogin ? openAvailabilityModal() : openRequireLoginModal()"
            :disabled="!isLogin"
          ></search-form>
          <select-availability-modal
            :items="availabilityItems"
            :isActive="activeAvailabilityModal"
            @close="closeAvailabilityModal"
            @add-availability="addAvailability"
            :isPaidUser="isPaidUser"
            :isAdmin="isAdmin"
            :hasCustomerId="hasCustomerId"
            :startDate="availabilityStartDate"
            :endDate="availabilityEndDate"
          />
          <require-login-modal
            :isActive="activeRequireLoginModal"
            @close="closeRequireLoginModal"/>
          <div class="center">
            <a :href="facilitiesLink" class="btn btn-primary">検索</a>
          </div>
        </div>
      </div>
    </div>
  </div> 
</template>
<script>
import '../packs/select_availability_modal'
import '../packs/require-login-modal'
import searchForm from './searchForm.vue'
import selectPlaceModal from './selectPlaceModal.vue'
import selectItemModal from './selectItemModal.vue'
import selectPriceModal from './selectPriceModal.vue'
export default {
  data() {
    return {
      placeItems: [],
      facilityTypeItems: [],
      sportsTypeItems: [],
      priceItems: [],
      tagItems: [],
      availabilityItems: [],
      emptyAvailabilityItems: [{label: '日時指定なし', startDate: null, endDate: null}],
      activePlaceModal: false,
      activeFacilityModal: false,
      activeFacilityTypeModal: false,
      activeSportsTypeModal: false,
      activePriceModal: false,
      activeTagModal: false,
      activeAvailabilityModal: false,
      activeRequireLoginModal: false,
    }
  },
  props: {
    places: {
      type: Array,
      default: () => []
    },
    facilityTypes: {
      type: Array,
      default: () => []
    },
    sportsTypes: {
      type: Array,
      default: () => []
    },
    prices: {
      type: Array,
      default: () => []
    },
    tags: {
      type: Array,
      default: () => []
    },
    availabilities: {
      type: Array,
      default: () => []
    },
    conditions: {
      type: Object,
      default: () => {}
    },
    isLogin: {
      type: Boolean,
      default: false
    },
    isPaidUser: {
      type: Boolean,
      default: false
    },
    isAdmin: {
      type: Boolean,
      default: false
    },
    isNoSearchAvailability: {
      type: Boolean,
      default: false
    },
    hasCustomerId: {
      type: Boolean,
      default: false
    }
  },
  components: {
    searchForm, selectPlaceModal, selectItemModal, selectPriceModal
  },
  methods: {
    createDataLayer(type, condition){
      window.dataLayer = window.dataLayer || [];
      dataLayer.push({
        event: 'search',
        search_info: {
          type: type,
          condition: condition
        }
      })
    },
    deletePlaceItem(id){
      this.placeItems = this.placeItems.filter(item => item.id != id)
      this.$refs.selectPlaceModal.$refs.selectAccordion.forEach(accordion => {
        const item = accordion.items.find(x => x.id == id);
        if(item){
          accordion.unSelectItemFromId(item.id)
        }
      });
    },
    deleteFacilityItem(id){
      this.facilityTypeItems = this.facilityTypeItems.filter(item => item.id != id);
      this.$refs.selectFacilityTypeModal.unSelectItemFromId(id)
    },
    deleteSportsTypeItem(id){
      this.sportsTypeItems = this.sportsTypeItems.filter(item => item.id != id);
      this.$refs.selectSportsTypeModal.unSelectItemFromId(id)
    },
    deletePriceItem(id){
      this.priceItems = this.priceItems.filter(item => item.id != id)
      this.$refs.selectPriceModal.$refs.selectAccordion.forEach(accordion => {
        const item = accordion.items.find(x => x.id == id);
        if(item){
          accordion.unSelectItemFromId(item.id)
        }
      });
    },
    deleteTagItem(id){
      this.tagItems = this.tagItems.filter(item => item.id != id);
      this.$refs.selectTagModal.unSelectItemFromId(id)
    },
    deleteAvailabilityItem(){
      this.availabilityItems = [];
    },
    openPlaceModal(){
      this.activePlaceModal = true;
    },
    closePlaceModal(){
      this.activePlaceModal = false;
    },
    addPlace(items){
      this.placeItems = items;
    },
    openFacilityTypeModal(){
      this.activeFacilityTypeModal = true;
    },
    closeFacilityTypeModal(){
      this.activeFacilityTypeModal = false;
    },
    addFacilityType(items){
      this.facilityTypeItems = items;
    },
    openSportsTypeModal(){
      this.activeSportsTypeModal = true;
    },
    closeSportsTypeModal(){
      this.activeSportsTypeModal = false;
    },
    addSportsType(items){
      this.sportsTypeItems = items;
    },
    openPriceModal(){
      this.activePriceModal = true;
    },
    closePriceModal(){
      this.activePriceModal = false;
    },
    addPrice(items){
      this.priceItems = items;
    },
    openTagModal(){
      this.activeTagModal = true;
    },
    closeTagModal(){ 
      this.activeTagModal = false;
    },
    addTag(items){
      this.tagItems = items;
    },
    openAvailabilityModal(){
      this.activeAvailabilityModal = true;
    },
    closeAvailabilityModal(){
      this.activeAvailabilityModal = false;
    },
    addAvailability(item){
      this.availabilityItems = [item.detail];
    },
    openRequireLoginModal(){
      this.activeRequireLoginModal = true;
    },
    closeRequireLoginModal(){
      this.activeRequireLoginModal = false;
    }
  },
  created(){
    // タグマネージャー用のデータレイヤーを作成
    this.conditions.cities.forEach(city => {
      this.createDataLayer('city', city.name)
    })
    this.conditions.facility_types.forEach(facility_type => {
      this.createDataLayer('facility_type', facility_type.name)
    })
    this.conditions.sports_types.forEach(sports_type => {
      this.createDataLayer('sports_type', sports_type.name)
    })

    this.placeItems = this.conditions.cities.map(x => ({id:x.id, label: x.prefecture_name + "/" + x.name}));
    this.facilityTypeItems = this.conditions.facility_types.map(x => ({id:x.id, label: x.name}));
    this.sportsTypeItems = this.conditions.sports_types.map(x => ({id:x.id, label: x.name}));
    this.priceItems = this.conditions.price_ranges.map(x => ({id:x.id, label: x.price_use_unit_name + "/" + x.name}));
    this.tagItems = this.conditions.tags.map(x => ({id:x.id, label: x.name}));
    console.log(this.conditions.availabilities)
    if(this.conditions.availabilities.length > 0){
      const availabilityDateRange = this.conditions.availabilities[0].name;
      console.log(availabilityDateRange)
      const startDate = availabilityDateRange.split('〜')[0].replace('年','-').replace('月','-').replace('日',' ').replace('時',':');
      const endDate = availabilityDateRange.split('〜')[1].replace('年','-').replace('月','-').replace('日',' ').replace('時',':');
      this.availabilityItems = [{startDate: startDate, endDate: endDate, label: availabilityDateRange}]
    }
    else {
      if(this.isNoSearchAvailability) this.availabilityItems = this.emptyAvailabilityItems;
    }
  },
  computed: {
    availabilityStartDate(){
      return this.availabilityItems.length > 0 ? this.availabilityItems[0].startDate : null
    },
    availabilityEndDate(){
      return this.availabilityItems.length > 0 ? this.availabilityItems[0].endDate : null
    },
    facilitiesLink(){
      const params = new URLSearchParams({
        page: 1,
        q: JSON.stringify({
          city_id_eq_any: this.placeItems.map(x => x.id),
          sports_types_id_eq_any: this.sportsTypeItems.map(x => x.id),
          facility_type_id_eq_any: this.facilityTypeItems.map(x => x.id),
          price_ranges_id_eq_any: this.priceItems.map(x => x.id),
          tags_id_eq_any: this.tagItems.map(x => x.id),
          availabilities_start_date_gteq: this.availabilityStartDate,
          availabilities_end_date_lteq: this.availabilityEndDate
        })
      }).toString()
      const origin = location.origin;
      const path = location.pathname;
      return `${origin}${path}?${params}`
    }
  },
  watch: {
    
  }
}
</script>